import React, { useMemo, PropsWithChildren } from "react";
import { CssBaseline, GlobalStyles } from "@mui/material";
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from "@mui/material/styles";
import global from "./global";
import palette from "./palette";
import typography from "./typography";
import breakpoints from "./breakpoints";
import ComponentsOverrides from "./overrides";
import shadows, { customShadows } from "./shadows";
import useSettings from "../../../react/hooks/useSettings";

export default function SomaLiveThemeProvider({ children }: PropsWithChildren) {
  const { themeMode, themeDirection } = useSettings();
  const isLight = themeMode === "light";

  const themeOptions = useMemo(
    () => ({
      palette: isLight ? palette.light : palette.dark,
      typography,
      breakpoints,
      shape: { borderRadius: 2 },
      direction: themeDirection,
      shadows: isLight ? shadows.light : shadows.dark,
      customShadows: isLight ? customShadows.light : customShadows.dark,
    }),
    [isLight, themeDirection]
  ) as any;

  const theme: any = createTheme(themeOptions);
  theme.components = ComponentsOverrides(theme);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <GlobalStyles styles={global} />
        <CssBaseline />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
